import React, { PureComponent, createElement, Children } from 'react';
import noop from 'lodash/noop';
import classNames from 'classnames';

class Tooltip extends PureComponent {
  static defaultProps = {
    hideOnMouseUp: false,
    inline: false,
    disabled: false,
  };

  state = { visible: false };

  handleMouseDown = this.props.hideOnMouseUp ? this.handleMouseOut : noop;

  handleMouseOver = () => {
    if (!this.props.disabled) {
      this.setState({ visible: true });
    }
  };

  handleMouseOut = () => {
    this.setState({ visible: false });
  };

  render() {
    if (!this.props.text) {
      return Children.only(this.props.children);
    }

    const wrapperClassName = classNames('ButtonWithTooltip', {
      'ButtonWithTooltip--manual': true,
      'ButtonWithTooltip--positionTop': this.props.position === 'top',
      'ButtonWithTooltip--alignEnd': this.props.align === 'end',
      'ButtonWithTooltip--alignStart': this.props.align === 'start',
      'd-ib': this.props.inline,
    });

    const tooltipClassName = classNames('ButtonWithTooltip-text', {
      'ButtonWithTooltip-text--visible': this.state.visible,
      [this.props.className]: this.props.className,
    });

    return (
      <div
        className={wrapperClassName}
        onMouseOver={this.handleMouseOver}
        onFocus={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
        onBlur={this.handleMouseOut}
        onMouseDown={this.handleMouseDown}
        onClick={() => {}}
        onKeyDown={() => {}}
      >
        {this.props.children}
        <div className={tooltipClassName}>{this.props.text}</div>
      </div>
    );
  }
}

export function withTooltip(props) {
  return children => createElement(Tooltip, { ...props, children });
}

export default Tooltip;
